module.exports = __webpack_public_path__ + "media/images/scan-4e22c656727e3fa348f8502d5eea64fc.png";